import { ModalConfirm } from './ModalConfirm/ModalConfirm';
import { ModalInformation } from './ModalInformation/ModalInformation';
import { ModalInfo } from './ModalInformation/type/ModalInfo';
import { ModalWarning } from './ModalInformation/type/ModalWarning';
import { ModalSuccess } from './ModalInformation/type/ModalSuccess';
import { ModalError } from './ModalInformation/type/ModalError';

export const Modal = {
  // TODO: Work more on Basic, Delete and Confirm
  // TODO: Work more on other specific footer
  Basic: ModalConfirm,
  Confirm: ModalConfirm,
  Delete: ModalConfirm,

  // For multiple purpose case
  Information: ModalInformation,

  // Specific Information Modal
  Info: ModalInfo,
  Warning: ModalWarning,
  Success: ModalSuccess,
  Error: ModalError,
};
